import { memo } from 'react';
import { useResponsive } from 'app/hooks';
import { Dialog, SVG, Text } from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { MobileHeader, MobileHeaderClose } from '../../../files.styled';

type DialogHeaderProps = {
  onClose: () => void;
};

export const DialogHeader = memo(({ onClose }: DialogHeaderProps) => {
  const { viewport } = useResponsive();

  if (viewport.desktop) {
    return <Dialog.Title>Добавление вложений</Dialog.Title>;
  }

  return (
    <MobileHeader>
      <MobileHeaderClose onClick={onClose}>
        <SVG src={Icons.Chevron} props={{ deg: 90 }} />
        <Text>Назад</Text>
      </MobileHeaderClose>

      <Dialog.Title align="center" style={{ flex: 1 }}>
        Добавление вложений
      </Dialog.Title>
    </MobileHeader>
  );
});
